import core, { type StateCore } from "@/modules/Core/store/core";
import filtros, { type StateFiltros } from "@/modules/Core/store/filtros";
import formulario, { type StateFormulario } from "@/modules/Configuracion/store/formularios";
import admisionRouting, { type StateAdmisionRouting } from '@/modules/Admision/store/admisionRouting'
import { createStore } from "vuex";
import componentsMigrate, { type StateComponentsMigrate } from "@/modules/Configuracion/store/componentsMigrate";
import odontograma, { type StateOdontograma } from "@/modules/Asistencial/store/odontograma";

export interface RootState {
    core: StateCore
    formulario: StateFormulario
    componentsMigrate: StateComponentsMigrate
    admisionRouting: StateAdmisionRouting
    filtros: StateFiltros
    odontograma: StateOdontograma
  }

  const store = createStore<RootState>({
    modules: {
        core,
        formulario,
        componentsMigrate,
        admisionRouting,
        filtros,
        odontograma
    }
  })

  export default store
